import React, { useEffect } from 'react';
import SEO from '../components/SEO';
import FAQ from '../components/FAQ';

const InvestorRelations = () => {
  useEffect(() => {
    if (window.jQuery) {
      const $ = window.jQuery;
      if ($.fn.tab) {
        $('.tab1').tab();
        $('.tab2').tab({ trigger_event_type: 'mouseover' });
      }
    }
    window.scrollTo(0, 0);
  }, []);

  const documents = [
    {
      name: 'INVESTOR COMPLAINT DATA JULY - 2026',
      file: 'Investor_Complaints_Data-Gatewayfin_July 2026.pdf',
    },
    { name: 'Investor Charter', file: 'Investor-Charter-SEBI.pdf' },
    { name: "DO'S AND DON'TS", file: "DO'S-AND-DON'TS.pdf" },
    {
      name: 'Rights and Obligations w.r.t Depository Participants',
      file: 'Rights-and-Obligations-w.r.t-Depository-Participants.pdf',
    },
    {
      name: 'Rights and Obligations w.r.t Stock Broker',
      file: 'Rights-and-Obligations-w.r.t-Stock-Broker.pdf',
    },
    {
      name: 'Uniform Risk Disclosure Document',
      file: 'Uniform-Risk-Disclosure-Document.pdf',
    },
    {
      name: 'Investor Charter for Depository Participants',
      file: 'Investor Charter for Depository Participants.pdf',
    },
  ];

  return (
    <div className="page-content">
      <SEO
        title="Investor Relations & Compliance Documents"
        description="Access investor complaint data, Investor Charter, and rights and obligations documents. Transparent compliance reporting for Gateway Financial investors."
      />
      <section id="banner-slider" className="inn-banner-slider">
        <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
          <div className="carousel-inner" role="listbox">
            <div
              className="carousel-item active"
              style={{
                backgroundImage: "url('/images/other-banner.png')",
              }}
            >
              <canvas id="canvas" aria-hidden="true"></canvas>
              <div className="carousel-caption">
                <h1>Investor Relations</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="welcome-section">
        <div className="container">
          <div className="row">
            {documents.map((doc, index) => (
              <div className="col-lg-6" key={index}>
                <div className="download-box">
                  <div className="media">
                    <img src="/images/pdf-icon.png" className="mr-3" alt="PDF Icon" />
                    <div className="media-body align-self-center">
                      <h5 className="mt-0 mb-2">{doc.name}</h5>
                      <a href={`/pdf/${doc.file}`} target="_blank" rel="noreferrer noopener">
                        <i className="fa fa-download" aria-hidden="true"></i> Download
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="app-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h3>Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services Limited</p>
              <a href="#download" className="lm-btn">
                Download &amp; Explore More
              </a>
            </div>
            <div className="col-lg-6">
              <img src="/images/app-pic.jpg" className="img-fluid" alt="Mobile App Preview" />
            </div>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default InvestorRelations;
